export const LG_DESKTOP_MIN_WIDTH: number = 1920;
export const DESKTOP_MIN_WIDTH: number = 1280;
export const TAB_MIN_WIDTH: number = 1024;
export const SM_TAB_MIN_WIDTH: number = 768;
export const MOBILE_MIN_WIDTH: number = 360;
export const SIDE_MENU_COLLAPSE: number = 1512;

export function isLargeDesktopAndAbove(): boolean {
  return window.innerWidth >= LG_DESKTOP_MIN_WIDTH;
}

export function isDesktopView(): boolean {
  return window.innerWidth >= DESKTOP_MIN_WIDTH;
}

export function isTabletView(): boolean {
  return window.innerWidth < DESKTOP_MIN_WIDTH;
}

export function isTabletAndAbove(): boolean {
  return window.innerWidth >= SM_TAB_MIN_WIDTH;
}

export function isTabletMin(): boolean {
  return window.innerWidth < TAB_MIN_WIDTH;
}

export function isMobileView(): boolean {
  return window.innerWidth < SM_TAB_MIN_WIDTH;
}

export function isSmallMobileView(): boolean {
  return window.innerWidth < MOBILE_MIN_WIDTH;
}

export function isSideMenuCollapsed(): boolean {
  return window.innerWidth < SIDE_MENU_COLLAPSE;
}

export function isLargeTabletAndAbove(): boolean {
  return window.innerWidth >= TAB_MIN_WIDTH;
}

export enum ResponsiveBreakpoints {
  XS_MOBILE_MIN = '(min-width: 360px)',
  XS_MOBILE_MAX = '(max-width: 359px)',
  SM_MOBILE_MIN = '(min-width: 360px)',
  SM_MOBILE_MAX = '(max-width: 767px)',
  SM_TABLET_MIN = '(min-width: 768px)',
  SM_TABLET_MAX = '(max-width: 767px)',
  MD_TABLET_MIN = '(min-width: 1024px)',
  LG_DESKTOP_MIN = '(min-width: 1280px)',
  LG_DESKTOP_MAX = '(max-width: 1919px)',
}